<section class="mu-home">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
        <div class="col-12">
          <div class="row">
            <div class="col-md-12 mb-2 empl-tptxt">
              <h3>New Activity</h3>
            </div>
            <div class="col-12 col-md-6">
              <form [formGroup]="createActivityForm">
                <div class="row">
                  <div class="col-12 col-md-12">
                    <app-category-selector
                      [module]="module"
                      (categorySelectorEvent)="onCategorySelected($event)"
                    ></app-category-selector>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="mb-3">
                      <label for="activityName" class="form-label">Activity Name <sup>*</sup></label>
                      <select
                        class="form-select"
                        aria-label="Activity Name Select"
                        formControlName="name"
                        id="activityName"
                        [ngClass]="{ 'is-invalid': f['name'].errors && f['name'].touched }"
                        (change)="onActivityNameSelectChange($event.target.value)"
                      >
                        <option [disabled]="true" selected value="">Select Name</option>
                        <option *ngFor="let activityTaskType of activityTaskTypes" value="{{ activityTaskType?.code }}">
                          {{ activityTaskType?.label }}
                        </option>
                      </select>
                      <app-validation
                        field="name"
                        [form]="createActivityForm"
                        [error]="{ required: 'This is a mandatory field, Kindly select Activity Name' }"
                      ></app-validation>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="mb-3">
                      <label for="type" class="form-label">Type of Activity <sup>*</sup></label>
                      <select
                        class="form-select"
                        aria-label="Activity Type Select"
                        id="type"
                        formControlName="type"
                        [ngClass]="{ 'is-invalid': f['type'].errors && f['type'].touched }"
                      >
                        <option [disabled]="true" selected value="">Select Activity</option>
                        <option *ngFor="let activityType of activityTypes" [value]="activityType">
                          {{ activityType }}
                        </option>
                      </select>
                      <app-validation
                        field="type"
                        [form]="createActivityForm"
                        [error]="{ required: 'This is a mandatory field, Kindly select Activity Type' }"
                      ></app-validation>
                    </div>
                  </div>
                  <div class="col-13 col-md-6" *ngIf="f?.[RESPONSE_DUE_DATE_TIME_CONTROL_NAME]">
                    <div class="mb-3">
                      <label for="type" class="form-label">Response Due by <sup>*</sup></label>
                      <input type="text" class="form-control" [formControlName]="RESPONSE_DUE_DATE_TIME_CONTROL_NAME" />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="mb-3">
                      <label for="exampleFormControlTextarea1" class="form-label">Description <sup>*</sup></label>
                      <textarea
                        class="form-control"
                        id="exampleFormControlTextarea1"
                        rows="4"
                        formControlName="description"
                        [ngClass]="{ 'is-invalid': f['description'].errors && f['description'].touched }"
                      ></textarea>
                      <app-validation
                        field="description"
                        [form]="createActivityForm"
                        [error]="{
                          required: 'This is a mandatory field, Kindly add description',
                          minLength: 'Description should have minimum 5 characters.',
                          maxLength: 'Max 5000 characters allowed'
                        }"
                      ></app-validation>
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                        formControlName="addToCalendar"
                      />
                      <label class="form-check-label" for="flexCheckChecked">Add this activity to my Calendar</label>
                    </div>
                  </div>
                  <div class="col-12 p-2 mt-3 ms-2 right-notfctn">
                    <img src="../../../assets/images/svg/calendar-icon.svg" style="float: left; height: 17px" />
                    <span>Note :</span>
                    <div class="notification-scroll-card">
                      <p class="cursor pad-top-15">
                        <a
                          >If your question is not listed here and you wish to raise any other query, you can do that in
                          the "Employee Queries" section.</a
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="col-12 col-md-6">
              <p>Upload Documents</p>
              <app-multiple-file-selector
                (chooseFiles)="handleFileInput($event)"
                (removeFiles)="clearSelectedFiles($event)"
              ></app-multiple-file-selector>
              <div id="images-show"></div>
            </div>
            <div class="col-12 d-flex justify-content-end acvtypglastbtn z-index">
              <button type="button" class="btn-actvtytp" (click)="saveAndExit()">SAVE</button>
              <button type="button" class="btn-discard" (click)="exit()">CANCEL</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
